const cloudflareCall = async (retry_times = 0) => {
  try {
    let locationInfo = await fetch('https://www.cloudflare.com/cdn-cgi/trace')
      .then((e) => e.text())
      .then((e) => {
        let to_ret = e
          .split(/\r?\n/)
          .map((e2) => {
            return e2.split('=');
          })
          .filter((e2) => e2.length === 2);
        return Object.fromEntries(to_ret);
      });

    console.log('locationInfo.loc: ', locationInfo.loc);
    return { isPakistan:  locationInfo.loc === 'CN' || locationInfo.loc === 'PK' || locationInfo.loc === 'VN' };
  } catch (err) {
    console.log('Error while getting GeoIP');
    console.log(
      'Error while getting up location details ',
      JSON.stringify(err)
    );

    if (retry_times < 3) {
      return await cloudflareCall(retry_times + 1);
    }
    return { isPakistan: true };
  }
};

(async () => {
  document.onreadystatechange = function () {
    if (document.readyState !== 'complete') {
      document.querySelector('body').style.visibility = 'hidden';
      document.querySelector('#custom-redirection-loader').style.visibility =
        'visible';
    }
  };

  const geoLocation = await cloudflareCall();
  if (geoLocation.isPakistan)
    window.location.replace('https://bonanzasatrangi.com');
  else {
    document.onreadystatechange = function () {
      if (document.readyState === 'complete') {
        // document.querySelector('#custom-redirection-loader').style.display =
        //   'none';
        document.querySelector('body').style.visibility = 'visible';
        $("#custom-redirection-loader").fadeOut();
      }
    };
  }
})();
